export var masks = {
  phoneNumber: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  date: [/[0-9]/, /\d/, '/', /\d/, /\d/]
};